const _ = require("lodash");

const Notification = require("./notification.js");

const template = require("notifications/templates/passive-notification.html");

class PassiveNotification extends Notification {
	constructor(options) {
		options = _.defaultsDeep(options || {}, {
			css: {
				"notification-passive": true
			},

			template: {
				html: template(),
				data: {
					message: options && options.message,
					isDanger: options.css && options.css["notification-danger"]
				}
			}
		});

		super(options);
	}
}

module.exports = PassiveNotification;
